import { ActivateAccount, Auth, Session } from "../models/bussines/Session";
import { ServiceResponse, FetchService } from "../shared";
import ServicePaths from "./ServicePaths";

export default class SessionService {
    public static Login(data: Auth): Promise<ServiceResponse<Session>> {
        return FetchService.post<Session>({
            url: ServicePaths.LOGIN,
            body: data,
        });
    }

    public static LogOut(): Promise<ServiceResponse<number>> {
        return FetchService.post<number>({
            url: ServicePaths.LOGOUT,
        });
    }

    public static ActivateAccount(
        data: ActivateAccount
    ): Promise<ServiceResponse<Session>> {
        return FetchService.put<Session>({
            url: ServicePaths.ACTIVATE_ACCOUNT,
            body: data,
        });
    }

    public static RecoverPassword(
        data: ActivateAccount
    ): Promise<ServiceResponse<Session>> {
        return FetchService.post<Session>({
            url: ServicePaths.RECOVER_PASSWORD,
            body: data,
        });
    }

    public static ChangePassword(
        data: ActivateAccount
    ): Promise<ServiceResponse<Session>> {
        return FetchService.put<Session>({
            url: ServicePaths.UPDATE_PASSWORD,
            body: data,
        });
    }

    public static IsUserLogged(): Promise<ServiceResponse<number>> {
        return FetchService.post<number>({
            url: ServicePaths.LOGOUT,
        });
    }
}
